<template>
  <div class="apartments">
    <div class="categoryTitleWrapper">
      <div class="gardeshgariTitle">{{ categoryName }}</div>
    </div>
    <div class="amlakFilterWrapper" :class="{ showShadow: showShadow }">
      <div class="wrapperContainer">
        <div class="searchBarWrapper">
          <div class="apartmentClassSearchBar">
            <div class="topNav__searchbar_wrapper">
              <div class="filterbutton_wrapper">
                <button ref="filterButton" class="filterbutton">
                  <VsxIcon
                    iconName="SearchNormal1"
                    :size="23"
                    color="#000"
                    type="linear"
                    @click="load_data('first')"
                  />
                </button>
              </div>
              <input
                type="search"
                inputmode="search"
                enterkeyhint="search"
                v-model="fillter.title"
                class="searchbar_input"
                placeholder="جستجوی املاک... (نام/شماره تماس)"
                @keyup.enter="load_data('first')"
              />
            </div>
          </div>
          <div class="resBackBtn" @click="historyBackHandler">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path
                d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"
              />
            </svg>
          </div>
        </div>
        <div class="amlakFilterList">
          <Swiper :slides-per-view="'auto'">
            <SwiperSlide>
              <div
                :class="[
                  'ChildShowTextSearchBar',
                  { selected: fillter.cid == 0 },
                ]"
                @click="selectSlide(0)"
              >
                <p title="همه">همه</p>
              </div>
            </SwiperSlide>
            <SwiperSlide v-for="(v, i) in category_list" :key="i">
              <div
                :class="[
                  'ChildShowTextSearchBar',
                  { selected: fillter.cid == v.id },
                ]"
                @click="selectSlide(v.id)"
              >
                <p :title="v.title">{{ v.title }}</p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
    <div
      style="margin-top: 30px"
      v-if="data_list.length == 0 && isLoading"
      class="apartmentsListContainer"
    >
      <Skeletor
        v-for="(v, i) in 12"
        :key="i"
        class="ChildShowTabToUserCustomer sliderBottm amlalListSk"
        height="353"
        style="
          background: rgb(163, 219, 213);
          margin-bottom: 2rem;
          border-radius: 10px;
        "
      />
    </div>

    <div v-show="data_list.length > 0 && !isLoading">
      <div class="realStatesListContainer">
        <div
          class="realStateThumb"
          v-for="(v, i) in data_list"
          @click="amlak_profile(v.id)"
          :key="i"
        >
          <div class="thumbPic">
            <img :src="v.avatar" :alt="v.title" />
          </div>
          <div class="thumbContent">
            <div class="contentHeader">
              <div class="realStateTitle">
                {{ v.title }}
                <div v-if="v.tick_color" class="realStateTick">
                  <VsxIcon
                    iconName="Verify"
                    :size="20"
                    :color="v.tick_color"
                    type="bold"
                  />
                </div>
              </div>
              <div class="realStateRate">
                <span>{{ v.user_rate }}</span>
                <i class="fa-solid fa-star"></i>
              </div>
              <div class="relStateLoc">
                <div class="locationIcon">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div class="locTitle">
                  {{ v.address }}
                </div>
              </div>
              <div class="realStatePhone">
                <div class="phoneIcon">
                  <i class="fa-solid fa-phone"></i>
                </div>
                <div class="phoneTitle">
                  {{ v.contact }}
                </div>
              </div>
            </div>
            <div class="contentFooter">
              <a :href="'tel:' + v.contact" class="footerCallBtn" @click.stop>
                <div class="callBtnIcon"><i class="fa-solid fa-phone"></i></div>
                <div class="callBtnTitle">تماس</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div
        ref="loadMoreTrigger"
        class="trigger"
        v-show="data_list.length > 0"
      ></div>
    </div>

    <div class="showMapBtn">
      <router-link to="/map-amlak" class="mapBtn">
        <div class="btnIcon">
          <VsxIcon iconName="Map1" :size="26" color="#fff" type="linear" />
        </div>
        <div class="btnTitle">نمایش مشاوران املاک روی نقشه</div>
      </router-link>
    </div>

    <!-- <div v-show="data_list.length > 0 && !isLoading">
      <div class="apartmentsListContainer">
        <div
          @click="amlak_profile(v.id)"
          class="property-list"
          v-for="(v, i) in data_list"
          :key="i"
          style="cursor: pointer"
        >
          <a>
            <article class="property">
              <header class="property__ref-info">
                <div class="property__picture">
                  <img
                    class="SowImageToUser"
                    :src="v.avatar"
                    :alt="v.title"
                    :style="
                      v.has_avatar
                        ? ''
                        : 'object-fit: contain;background: #f5f5f5;'
                    "
                  />
                </div>
              </header>
              <section class="property__main-info">
                <div class="adviserTitle">
                  <h3 class="property__title">
                    {{ v.title }}
                  </h3>

                  <div
                    v-if="v.tick_color"
                    class="accommodation-pdp-specification"
                  >
                    <VsxIcon
                      iconName="Verify"
                      :size="20"
                      :color="v.tick_color"
                      type="linear"
                    />
                  </div>
                </div>
                <span class="property__location" v-if="v.address">
                  <VsxIcon
                    iconName="Location"
                    :size="24"
                    color="#0096c7 "
                    type="linear"
                  />
                  <span>
                    {{ v.address }}
                  </span>
                </span>
                <span class="property__location contactInfo" v-if="v.contact">
                  <VsxIcon
                    iconName="Call"
                    :size="24"
                    color="#0096c7 "
                    type="linear"
                  />
                  <span>
                    {{ v.contact }}
                  </span>
                </span>
                <spa class="property_contact" v-if="v.contact">
                  <a :href="'tel:' + v.contact" class="callBtn" @click.stop>
                    تماس
                    <VsxIcon
                      iconName="CallCalling"
                      :size="18"
                      color="#fff"
                      type="linear"
                    />
                  </a>
                </spa>
              </section>
            </article>
          </a>
        </div>
      </div>

      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div
        ref="loadMoreTrigger"
        class="trigger"
        v-show="data_list.length > 0"
      ></div>
    </div> -->

    <!-- <div
      v-if="data_list.length > 0 && loadmore && !isLoading"
      class="apartmentsLoadMoreDataButton"
    >
      <button
        class="loadButton"
        @click="load_data()"
        :disabled="loadmore_loading"
      >
        <span v-if="!loadmore_loading">نمایش بیشتر</span>
        <span v-else class="loader"></span>
      </button>
    </div> -->

    <div
      v-if="data_list.length == 0 && !isLoading"
      class="justify-center align-center mt-4"
      style="text-align: center; height: 90%"
    >
      <img
        :src="publicPath + 'img/notfound.png'"
        alt="Alt text"
        width="320"
        height="280"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Skeletor } from "vue-skeletor";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

export default {
  name: "amlakList",
  components: {
    Skeletor,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      isLoading: false,
      loadmore: false,
      loadmore_loading: false,
      showItemNum: 11.6,
      fillter: {
        title: "",
        cid: 0,
        page: 1,
        per_page: 12,
      },
      category_list: [],
      data_list: [],
      categoryName: "",
      showShadow: false,
    };
  },
  methods: {
    handleWindowScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;

      // اگر کاربر تقریبا به انتهای صفحه رسیده باشه (مثلا ۱۰۰ پیکسل مونده باشه)
      if (scrollTop + windowHeight + 100 >= fullHeight) {
        // اگر لودموره فعاله و درحال لود نیستیم
        if (this.loadmore && !this.loadmore_loading) {
          this.load_data(); // دقت کن بدون "first" پارامتر
        }
      }

      if (window.innerWidth < 700 && window.scrollY > 86) {
        this.showShadow = true;
      } else {
        this.showShadow = false;
      }
    },
    async load_category() {
      const r = await axios.get(
        this.$store.getters.baseUrl + "/branch-cat-list"
      );
      if (r.data.result != "0") {
        this.category_list = r.data.list;
      }
      console.log("category_list", this.category_list);
    },
    historyBackHandler() {
      history.back();
    },
    selectSlide(index) {
      this.fillter.cid = index;
      if (index === 0) {
        this.$router.replace({ query: { ...this.$route.query, cid: 'all' } });
      } else {
        this.$router.replace({ query: { ...this.$route.query, cid: index } });
      }
      this.load_data("first");
      this.categoryNameHandler();
    },
    categoryNameHandler() {
      const cat = this.category_list.find(
        (list) => this.fillter.cid == list.id
      );
      this.categoryName = cat ? cat.title : "همه مشاوران املاک";
    },
    calculateItemsToShow() {
      const width = window.innerWidth;
      if (width > 1200) {
        return 11.6;
      } else if (width > 1000) {
        return 8.5;
      } else if (width > 600) {
        return 6.5;
      } else {
        return 6.5;
      }
    },
    updateCarouselConfig1() {
      const itemsToShow = this.calculateItemsToShow();
      this.showItemNum = itemsToShow;
    },
    load_data(param) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.data_list = [];
        this.fillter.page = 1;
      }
      axios
        .post(this.$store.getters.baseUrl + "/branch-list-all", this.fillter)
        .then((r) => {
          if (r.data.result == 0 && param == "first") {
            this.data_list = [];
            if (param != "first") {
              this.fillter.page -= 1;
            }
          } else {
            this.data_list = this.data_list.concat(r.data.list.list);
            if (r.data.list.total_page == this.fillter.page) {
              this.loadmore = false;
            }
          }
          this.isLoading = false;
          this.loadmore_loading = false;
        });
    },
    amlak_profile(bid) {
      this.$router.push({ path: "/profile-amlak", query: { bid } });
    },
  },
  async mounted() {
    const cid = this.$route.query.cid;
    if (!cid || cid == 'all') {
      this.fillter.cid = 0;
    } else {
      this.fillter.cid = cid;
    }
    await this.load_data("first");
    await this.load_category();
    this.categoryNameHandler();
    window.addEventListener("resize", this.updateCarouselConfig1);
    window.addEventListener("scroll", this.handleWindowScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateCarouselConfig1);
  },
};
</script>

<script setup>
// import { ref, onMounted, onBeforeUnmount, onUnmounted } from "vue";
// import store from "@/store";
// import axios from "axios";
// import { useRoute, useRouter } from "vue-router/dist/vue-router";
// import { Skeletor } from "vue-skeletor";
// import { Swiper, SwiperSlide } from "swiper/vue";
// import "swiper/css";
// import Treeselect from "vue3-treeselect";
// import "vue3-treeselect/dist/vue3-treeselect.css";

// const publicPath = ref(process.env.VUE_APP_PUBLIC_PATH);

// const isLoading = ref(true);
// const loadmore = ref(false);
// const loadmore_loading = ref(false);
// const router = useRouter();
// const showItemNum = ref(11.6);

// const fillter = ref({
//   title: "",
//   cid: 0,
//   page: 1,
//   per_page: 12,
// });

// const handleWindowScroll = () => {
//   const scrollTop = window.scrollY || document.documentElement.scrollTop;
//   const windowHeight = window.innerHeight;
//   const fullHeight = document.documentElement.scrollHeight;

//   // اگر کاربر تقریبا به انتهای صفحه رسیده باشه (مثلا ۱۰۰ پیکسل مونده باشه)
//   if (scrollTop + windowHeight + 100 >= fullHeight) {
//     // اگر لودموره فعاله و درحال لود نیستیم
//     if (loadmore.value && !loadmore_loading.value) {
//       load_data(); // دقت کن بدون "first" پارامتر
//     }
//   }
// };

// onMounted(async () => {
//   await load_data("first");
//   await load_category();
//   categoryNameHandler();
//   window.addEventListener("resize", updateCarouselConfig1);
//   window.addEventListener("scroll", handleWindowScroll);
//   // const observer = new IntersectionObserver(
//   //   ([entry]) => {
//   //     if (entry.isIntersecting) {
//   //       load_data();
//   //     }
//   //   },
//   //   { threshold: 1.0 }
//   // );
//   // if (loadMoreTrigger.value) {
//   //   observer.observe(loadMoreTrigger.value);
//   // }
// });

// const category_list = ref([]);
// const load_category = async () => {
//   const r = await axios.get(store.getters.baseUrl + "/branch-cat-list");
//   category_list.value = r.data.list;
//   console.log("category_list", category_list.value);
// };

// const selectSlide = (index) => {
//   fillter.value.cid = index;
//   if (index === 0) {
//     router.replace({ query: {} });
//   } else {
//     router.replace({ query: { ...route.query, cid: index } });
//   }
//   load_data("first");
//   categoryNameHandler();
// };

// const categoryName = ref("");

// const categoryNameHandler = () => {
//   const cat = category_list.value.find((list) => fillter.value.cid == list.id);
//   categoryName.value = cat ? cat.title : "همه مشاوران املاک";
// };

// const calculateItemsToShow = () => {
//   const width = window.innerWidth;
//   if (width > 1200) {
//     return 11.6;
//   } else if (width > 1000) {
//     return 8.5;
//   } else if (width > 600) {
//     return 6.5;
//   } else {
//     return 6.5;
//   }
// };

// const updateCarouselConfig1 = () => {
//   const itemsToShow = calculateItemsToShow();
//   showItemNum.value = itemsToShow;
// };

// onBeforeUnmount(() => {
//   window.removeEventListener("resize", updateCarouselConfig1);
// });

// onUnmounted(() => {
//   window.removeEventListener("scroll", handleWindowScroll);
// });

// const loadMoreTrigger = ref(null);

// const route = useRoute();
// const data_list = ref([]);
// const load_data = (param) => {
//   loadmore.value = true;
//   loadmore_loading.value = true;
//   fillter.value.page += 1;
//   if (param == "first") {
//     isLoading.value = true;
//     data_list.value = [];
//     fillter.value.page = 1;
//     const cid = route.query.cid;
//     if (cid && fillter.value.cid === 0) {
//       fillter.value.cid = parseInt(cid);
//     }
//   }
//   axios
//     .post(store.getters.baseUrl + "/branch-list-all", fillter.value)
//     .then((r) => {
//       if (r.data.result == 0 && param == "first") {
//         data_list.value = [];
//         if (param != "first") {
//           fillter.value.page -= 1;
//         }
//       } else {
//         data_list.value = data_list.value.concat(r.data.list.list);
//         console.log("مهسفیشش", r.data.list);
//         if (r.data.list.total_page == fillter.value.page) {
//           loadmore.value = false;
//         }
//       }
//       isLoading.value = false;
//       loadmore_loading.value = false;
//     });
// };

// const amlak_profile = (bid) => {
//   // let main_cat=checkTab.value;
//   router.push({ path: "/profile-amlak", query: { bid } });
// };
</script>

<style lang="scss" scoped>
.ShowTabToUserCustomer {
  width: 100% !important;
}

.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.classShowApartmentSow {
  position: relative;
}

.deleteIcon {
  position: absolute;
  top: 4%;
  left: 4%;
  width: 32px;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    font-size: 1.25rem;
    color: #2dc635;
  }
}

.adviserosSearchBox {
  position: relative;
  flex-direction: row !important;

  .searchbar_input {
    width: 100%;
    padding: 0 4%;
  }

  .searchBtn {
  }
}

.adviserTitle {
  display: flex;
  align-items: center;

  .property__title {
    max-width: calc(100% - 25px);
  }
}

.property-list {
  a .property {
    .property__main-info {
      position: relative;
      min-height: 210px;
      .property__location {
        align-items: flex-start;
        svg {
          flex-shrink: 0;
        }

        &.contactInfo {
          span {
            font-size: 16px;
          }
        }

        span {
          flex: 1;
          line-height: 1.35rem;
          font-size: 14px;
        }
      }
    }
  }
}

.swiper {
  padding: 2px 1px;
  .swiper-slide {
    width: auto;
  }
}

.amlakFilterList {
  width: 100%;
  margin-top: 20px;
  margin-bottom: -9px;

  .ChildShowTextSearchBar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    // width: 100%;
    padding: 0 18px;
    border-radius: 0.375rem;
    border: 1px solid rgb(209, 213, 219);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    color: #000;
    margin-left: 9px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.1s;
    background: #faf9fb;

    &.selected {
      border: 1px solid #0096c7;
      background: #0096c7;
      color: #fff;
    }
  }
}

.property_contact {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  width: 100%;
  padding: 0 10px;

  .callBtn,
  .smsBtn {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0096c7;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;

    svg {
      margin-right: 4px;
    }
  }
}

.showMapBtn {
  position: fixed;
  bottom: 32px;
  left: 0;
  right: 0;
  z-index: 998;

  .mapBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 20px;
    height: 48px;
    background: #0096c7;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    width: fit-content;
    margin: 0 auto;
    border-radius: 24px;
    border: 1px solid #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  }
}

.dark {
  .categoryTitleWrapper {
    .gardeshgariTitle {
      color: #fff !important;
    }
  }
}

.categoryTitleWrapper {
  width: 100%;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 24px;

  .gardeshgariTitle {
    width: 100% !important;

    &::after,
    &::before {
      width: 90px !important;
    }
  }
}

@media (min-width: 700px) {
  .categoryTitleWrapper {
    display: none;
  }
}
</style>
